import type { CourseModule } from "@/core/types";
import { lektionSuchenErsetzen } from "./lektion-01-suchen-ersetzen";
import { lektionRechtschreibung } from "./lektion-02-rechtschreibung";
import { lektionSprache } from "./lektion-03-sprache";
import { lektionStatistik } from "./lektion-04-statistik";
import { lektionSuchenAbschluss } from "./lektion-05-abschluss";

export const modulSuchen: CourseModule = {
  id: "suchen",
  title: "Suchen, Ersetzen und Sprache",
  summary:
    "Änderungen im ganzen Dokument in einem Zug, Rechtschreibprüfung richtig " +
    "einsetzen und die Textsprache in den Griff bekommen.",
  level: "Grundlagen",
  lessons: [
    lektionSuchenErsetzen,
    lektionRechtschreibung,
    lektionSprache,
    lektionStatistik,
    lektionSuchenAbschluss,
  ],
};
